// Shared credential badges used across all landing pages
export const credentialBadges = [
  { 
    src: 'https://crowdstake-website-images-prod.s3.us-east-2.amazonaws.com/user-81cb0550-3031-701e-31f9-b6f078c381e0/878aa211-b635-4c12-813e-aa2b27a5743c_optimized.webp', 
    alt: 'IRS Certified PEO' 
  },
  { 
    src: 'https://crowdstake-website-images-prod.s3.us-east-2.amazonaws.com/user-81cb0550-3031-701e-31f9-b6f078c381e0/2fa2d2a8-d14d-461e-987c-1497addbae26_optimized.webp', 
    alt: 'ESAC Accredited' 
  },
  { 
    src: 'https://crowdstake-website-images-prod.s3.us-east-2.amazonaws.com/user-81cb0550-3031-701e-31f9-b6f078c381e0/c858736e-9945-4dfa-8857-2ba3179df604_optimized.webp', 
    alt: 'Forbes Advisor Best of 2025' 
  },
  { 
    src: 'https://crowdstake-website-images-prod.s3.us-east-2.amazonaws.com/user-81cb0550-3031-701e-31f9-b6f078c381e0/7cd77e8e-75b3-486f-af80-91e17f897749_optimized.webp', 
    alt: 'Inc. 5000 4-Time Winner' 
  },
  { 
    src: 'https://crowdstake-website-images-prod.s3.us-east-2.amazonaws.com/user-81cb0550-3031-701e-31f9-b6f078c381e0/971823ce-d641-484e-ae67-a9a9ea8872f3_optimized.webp', 
    alt: 'G2 Users Love Us' 
  }
];
